import * as React from "react";
interface SVGProps {
  height?: number | string;
  width?: number | string;
  color?: string;
}

const SvgRebirthLogo = (props: SVGProps) => {
  return (
    <svg width="1em" height="1em" viewBox="0 0 122 32" fill="none" {...props}>
      <path
        d="M82.3 6.613c-2.158 0-3.822.769-5.366 2.374v-2h-4.238v19.68h4.56V15.253c0-2.613 1.556-4.266 3.917-4.266.429 0 .805.053 1.073.106l3.165-4.16c-1.234-.213-2.307-.32-3.112-.32zM121.625 6.987h-5.258l-4.855 6.419-4.855-6.42h-5.258l7.418 9.917-7.418 9.764h5.365l4.721-6.226 4.721 6.226h5.419l-7.468-9.748 7.468-9.932zM25.86 2.56c-1.556 2.08-1.932 2.773-3.434 2.773H0V32h8.799c1.985 0 3.916-.96 5.15-2.56 1.61-2.133 1.824-2.773 3.38-2.773h22.48V0h-8.853c-1.985 0-3.916.96-5.097 2.56zm6.974 17.227h-9.389c-2.039 0-3.916.853-5.15 2.506-1.61 2.134-1.932 2.774-3.434 2.774h-7.94v-12.8h9.389c2.038 0 3.916-.96 5.15-2.56 1.61-2.08 2.039-2.72 3.487-2.72h7.887v12.8zM66.526 13.227c1.986-1.12 3.38-3.094 3.38-5.707 0-3.84-2.95-7.52-7.242-7.52H49.788v26.667h12.876c4.667 0 7.886-3.307 7.886-7.467 0-2.453-1.126-4.587-4.024-5.973zM54.348 4.16h7.94c1.985 0 3.165 1.867 3.165 3.52 0 2.027-1.77 3.413-3.433 3.413h-7.672V4.16zm7.672 18.347h-7.672v-7.254h7.94c2.039 0 3.702 1.76 3.702 3.574 0 2.026-2.092 3.68-3.97 3.68z"
        fill="currentColor"
      />
      <path
        d="M96.839 21.013c-.751 1.174-2.2 1.867-3.81 1.867-2.52 0-4.613-1.707-4.613-4.32h13.627c.215-.8.268-1.173.268-1.867 0-5.973-3.702-10.08-9.281-10.08-5.473 0-9.335 3.894-9.335 10.24 0 6.187 3.701 10.187 9.442 10.187 4.024 0 7.565-1.973 8.584-6.027h-4.882zm-3.81-10.24c2.522 0 4.454 1.6 4.4 4h-8.96c0-2.346 2.04-4 4.56-4z"
        fill="currentColor"
      />
    </svg>
  );
};

export default SvgRebirthLogo;
